(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
      , 'chart.js'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsProductivityController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'LangService', 'NotificationService', 'LocalStorageService'];

  function reports ($scope, $http, $timeout, ngTableParams, LangService, NotificationService, LocalStorageService) {
    if (LocalStorageService.checkInPause()) {
      LocalStorageService.sendToBlockPage();
    }

    var vm = this;
    $scope.vm = vm;

    LangService
      .getPageLabels({ 'page': 'menu.reports.prod' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.loading = false;

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.download = function () {
      vm.filters['mexicoReport'] = window.location.pathname.includes('productivity-mexico');
      $http.get(apiUrl + '/reports/productivity', {
        params: {
          filters: vm.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success === false) {
            NotificationService.errorHandler(data, vm.labels.errorReport);
            return;
          }

          var filename = headers('Mktzap-Filename') || vm.labels.productivity;

          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' }); // Make sure it's not visible
          angular.element(document.body).append(anchor); // Attach to document

          var blob = new Blob([data], { type: 'text/csv' });
          var csvUrl = URL.createObjectURL(blob);

          anchor.attr({
            href: csvUrl,
            target: '_self',
            download: filename
          })[0].click();

          anchor.remove(); // Clean it up afterwards
          URL.revokeObjectURL(csvUrl); // Clean memory blob
        }, function ({ data }) {
          NotificationService.errorHandler(data, vm.labels.errorReport);
        })
    };
  }
})();
